module.exports = __webpack_public_path__ + "static/media/budget.7e8303a3.JPG";